// The labs you belong to (PI, member or alumni), as the sidebar lists them. Call refreshMyLabs()
// after anything that changes them: creating or deleting a lab, accepting an invitation, leaving.
import useSWR, { mutate } from 'swr';
import { fetcher } from 'shared/helpers/axios';

export const MY_LABS_KEY = '/consortium/labs/?mine=1';

export function useMyLabs(enabled = true) {
  const { data } = useSWR(enabled ? MY_LABS_KEY : null, fetcher, { revalidateOnFocus: false });
  return Array.isArray(data) ? data : data?.results || [];
}

export const refreshMyLabs = () => mutate(MY_LABS_KEY);
